import { SelectComponent as Select } from './Select';

export default Select;
